import { InternalAssociationMetaData } from './domain-model-meta-data';

export class InternalRelationMetaData extends InternalAssociationMetaData {

}
